import styled from "styled-components";
import { breakpoints, buildColor } from "@tvg/design-system";

export const ScrollablePicksContainer = styled.div<{
  contentHeight: string;
}>`
  overflow-y: auto;
  max-height: 100vh;
  height: ${({ contentHeight }) => contentHeight};
  scroll-behavior: smooth;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: ${({ theme }) => theme.colors.blue["000"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    gap: 8px;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    max-height: initial;
    scroll-snap-type: x mandatory;
    scroll-snap-stop: always;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const RaceCardPicksContainer = styled.div`
  height: fit-content;
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 4px;
  overflow: hidden;

  @media screen and ${breakpoints.tablet.max.sm} {
    border-radius: 8px;
    border: 1px solid ${buildColor("blue", "100")};
    box-shadow: 0 2px 4px 0 rgba(17, 43, 68, 0.14);
    scroll-snap-align: center;

    &:not(:first-of-type),
    &:not(:last-of-type) {
      width: calc(100vw - 32px);
    }

    &:first-of-type {
      margin-left: 12px;
    }

    &:last-of-type {
      margin-right: 12px;
    }
  }
`;

export const LegsPicker = styled.div`
  padding: 12px;
  box-shadow: ${({ theme }) =>
    `inset 0px -2px 0px ${theme.colors.blue["100"]}`};
`;

export const RaceCardWrapper = styled.div`
  height: fit-content;
  flex: none;
  width: 100%;
  overflow: hidden;

  @media screen and ${breakpoints.tablet.max.sm} {
    width: calc(100vw - 16px);
  }
`;

export const FPPContainer = styled.div`
  margin-left: 13px;
  width: calc(100% - 18px);
  margin-top: 12px;
  box-shadow: 0 2px 4px 0 rgba(17, 43, 68, 0.14);
  border-radius: 8px;
  overflow: hidden;
`;
